var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333374 26.9999C0.333374 12.2723 12.2724 0.333252 27 0.333252C34.0725 0.333252 40.8553 3.14277 45.8562 8.14374C50.8572 13.1447 53.6667 19.9275 53.6667 26.9999C53.6667 41.7275 41.7276 53.6666 27 53.6666C12.2724 53.6666 0.333374 41.7275 0.333374 26.9999ZM5.66671 26.9999C5.66671 38.782 15.218 48.3333 27 48.3333C32.658 48.3333 38.0842 46.0857 42.085 42.0849C46.0858 38.0841 48.3334 32.6579 48.3334 26.9999C48.3334 15.2178 38.7821 5.66659 27 5.66659C15.218 5.66659 5.66671 15.2178 5.66671 26.9999ZM29.6667 28.3333C29.6667 27.5969 29.0698 26.9999 28.3334 26.9999H25.6667C24.9303 26.9999 24.3334 27.5969 24.3334 28.3333V36.3333C24.3334 37.0696 24.9303 37.6666 25.6667 37.6666H28.3334C29.0698 37.6666 29.6667 37.0696 29.6667 36.3333V28.3333ZM28.3334 16.3333C29.0698 16.3333 29.6667 16.9302 29.6667 17.6666V20.3333C29.6667 21.0696 29.0698 21.6666 28.3334 21.6666H25.6667C24.9303 21.6666 24.3334 21.0696 24.3334 20.3333V17.6666C24.3334 16.9302 24.9303 16.3333 25.6667 16.3333H28.3334Z",
    fill: "#EF8123"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/info-outline.d2a70400b101e7cefef780d3c95943d2.svg";
export { ForwardRef as ReactComponent };